import { fetchWrapper } from "@/helpers";

const ruta = process.env.VUE_APP_ROOT_API;

export default class RecetaService {
    /**
     * Crea una nueva receta
     * @param {Object} datos - Datos del formulario de receta
     * @returns {Promise} Promesa con la respuesta de la API.
     */
    async guardarReceta(datos) {
        return await fetchWrapper.post(`${ruta}/recetas`, datos);
    }

    /**
     * Actualiza una receta existente
     * @param {number} id - ID de la receta
     * @param {Object} datos - Datos de la receta a actualizar
     * @returns {Promise} Promesa con la respuesta de la API.
     */
    async actualizarReceta(id, datos) {
        return await fetchWrapper.put(`${ruta}/recetas/${id}`, datos);
    }

    /**
     * Obtiene la lista paginada de recetas.
     * @param {Object} params - Parámetros de consulta (ej. { solo_activas: 1, per_page: 20 })
     * @returns {Promise} Promesa con la respuesta de la API.
     */
    async obtenerRecetas(params = {}) {
        // Convertimos el objeto params a una query string para la petición GET
        const queryString = new URLSearchParams(params).toString();
        const url = queryString ? `${ruta}/recetas?${queryString}` : `${ruta}/recetas`;
        
        return await fetchWrapper.get(url);
    }

    /**
     * Obtiene una receta específica con todos sus detalles (insumos).
     * @param {number} id - ID de la receta.
     * @returns {Promise} Promesa con los datos de la receta.
     */
    async obtenerReceta(id) {
        return await fetchWrapper.get(`${ruta}/recetas/${id}`);
    }

    /**
     * Elimina (soft delete) una receta.
     * @param {number} id - ID de la receta a eliminar.
     * @returns {Promise}
     */
    async eliminarReceta(id) {
        return await fetchWrapper.delete(`${ruta}/recetas/${id}`);
    }

    /**
     * Fuerza el recálculo del costo teórico de una receta.
     * @param {number} id - ID de la receta.
     * @returns {Promise} Promesa con la receta actualizada.
     */
    async recalcularCosto(id) {
        return await fetchWrapper.post(`${ruta}/recetas/${id}/recalcular-costo`);
    }
}
